// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mentions_milestone_ping-cls1___951716d2aab0ee110dc{/*!*/}.mentions_milestone_ping-cls2__d852d43f4040f1493672{display:flex;flex-direction:column;flex-wrap:wrap;justify-content:center;max-width:100%;font-size:16px;line-height:22px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "mentions_milestone_ping-cls1___951716d2aab0ee110dc",
	"cls2": "mentions_milestone_ping-cls2__d852d43f4040f1493672 mentions_milestone_ping-cls1___951716d2aab0ee110dc"
};
export default ___CSS_LOADER_EXPORT___;
